import React from "react";
import { StyledGrid } from "@hcl-commerce-store-sdk/react-component";
import {
  StyledBox,
  StyledIconButton,
  StyledListItemButton,
  StyledListItemIcon,
  StyledTypography,
} from "../../../../styled-mui";
import { SvgClose } from "../../../svg/close";
import { HeaderMobileMegaMenuSX } from "../../headerMegaMenu";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { StyledButton } from "../../../../styled-mui";
import { SvgMyProjectNew } from "../../../svg/myProject";
import { PRISEDERDV } from "../../../../constants/routes";
import { StoreLocatorButton } from "../.././storeLocatorButton";
import { CLICK } from "../../../../_foundation/constants/gtm";
import AsyncCall from "../../../../_foundation/gtm/async.service";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import calque from "../../../svg/Calque.svg";

interface MenuWrapperProps {
  title: string;
  children: React.ReactNode | React.ReactNode[];
  isASubMenu?: boolean;
  entireMenuCloseHandler: () => any;
  closeCurrentMenu?: () => any;
  setOpenAppointmentModal?: (open: boolean) => void;
}

const MobileMenuWrapper: React.FC<MenuWrapperProps> = ({
  children,
  title,
  isASubMenu = false,
  entireMenuCloseHandler,
  closeCurrentMenu,
  setOpenAppointmentModal,
}) => {
  const { t } = useTranslation();
  return (
    <StyledGrid container className="menu-container">
      <StyledGrid
        container
        p={5}
        className="menu-mobile-navigation-top"
        style={{ display: "flex", justifyContent: "center", alignItems: "center", flexWrap: "nowrap" }}>
        <StyledGrid item py={1}>
          <StyledTypography
            variant="h5"
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              textTransform: "none",
              color: isASubMenu ? "rgb(66, 66, 66)" : "#848484",
              overflow: "hidden",
            }}>
            {isASubMenu && (
              <ChevronLeftIcon
                sx={{ fontSize: "30px", color: "red", marginRight: "10px" }}
                onClick={() => closeCurrentMenu && closeCurrentMenu()}
              />
            )}
            {title}
          </StyledTypography>
        </StyledGrid>

        <StyledGrid item p={1} className="menu-mobile-navigation-top-svg-close">
          <StyledIconButton onClick={entireMenuCloseHandler}>
            <SvgClose color="black" />
          </StyledIconButton>
        </StyledGrid>
      </StyledGrid>

      <StyledBox component="nav" sx={HeaderMobileMegaMenuSX.navItemWrapper}>
        {children}
      </StyledBox>

      <StyledBox sx={HeaderMobileMegaMenuSX.navStaticbutton}>
        <StoreLocatorButton />
        {/* <StyledListItemButton
          component="a"
          href="tel:0801010538"
          sx={{ display: "flex", justifyContent: "center" }}
          onClick={() => {
            AsyncCall.sendPageClickCtaEvent({
              event: "click_hotline",
              btn_label: "hotline",
            });
          }}>
          <StyledListItemIcon>
            <img
              src={calque}
              alt="hotline"
              style={{
                width: 29,
                height: 30,
                objectFit: "contain",
              }}
            />
          </StyledListItemIcon>
          <StyledTypography
            sx={{
              color: "#D73346",
              fontSize: "16px",
              fontWeight: "700",
              lineHeight: "24px",
              fontStyle: "ExtraBold",
              marginLeft: "8px",
            }}>
            08 01 01 05 38
          </StyledTypography>
        </StyledListItemButton> */}
        <StyledButton
          fullWidth
          startIcon={<SvgMyProjectNew />}
          size="medium"
          variant="outlined"
          color="primary"
          onClick={() => {
            AsyncCall.sendPageClickCtaEvent({ event: CLICK.CONTACT, btn_label: "a votre ecoute" });
            setOpenAppointmentModal && setOpenAppointmentModal(true);
            entireMenuCloseHandler && entireMenuCloseHandler();
          }}
          sx={{
            mt: 3,
            mb: 3,
            backgroundColor: "white",
            color: "primary.main",
            borderColor: "primary.main",
            borderWidth: "2px",
            textTransform: "none",
          }}>
          {t("Header.Actions.AtYourService")}
        </StyledButton>
      </StyledBox>
    </StyledGrid>
  );
};

export default MobileMenuWrapper;
